import React from 'react';

import { Box } from '@vk-hr-tek/ui/Box';
import { useInject } from '@vk-hr-tek/core/ioc';
import { TruncatedText } from '@vk-hr-tek/ui/TruncatedText';
import { Typography } from '@vk-hr-tek/ui/Typography';
import { Callout } from '@vk-hr-tek/ui/Callout';

import { ContentSurveysPassingMapper } from '../../mappers';
import { StatisticsTypes } from '../../types';

import { SurveyAnalyticsTextAnswer } from './SurveyAnalyticsTextAnswer';

interface SurveyAnalyticsScaleComponentProps {
  statistics: StatisticsTypes;
  canDownloadReport: boolean;
}

export const SurveyAnalyticsAnswer = ({
  statistics,
  canDownloadReport,
}: SurveyAnalyticsScaleComponentProps) => {
  const mapper = useInject(ContentSurveysPassingMapper);

  const answerType = statistics.answer_type;

  if (answerType === 'single_choice' || answerType === 'multiple_choice') {
    const processAnswer = mapper.processAnalyticsStatisticsAnswer(statistics);

    return (
      <Box
        display="flex"
        flexDirection="column"
        bgcolor="bg.light.primary"
        radius="m"
        px="12"
        py="16"
      >
        {processAnswer.options?.map((option) => (
          <SurveyAnalyticsTextAnswer
            key={option.id}
            {...option}
            selected={option.is_selected}
          />
        ))}
        {processAnswer.otherValueStats && (
          <SurveyAnalyticsTextAnswer
            key={`${processAnswer.otherValueStats.answer_count}${processAnswer.otherValueStats.percentage}`}
            is_edited={false}
            answer_count={0}
            percentage={0}
            selected={processAnswer.otherValueStats.is_selected}
            otherValueStats={processAnswer.otherValueStats}
          />
        )}
      </Box>
    );
  }

  if (answerType === 'free_text') {
    const processAnswer = mapper.processAnalyticsStatisticsAnswer(statistics);

    return (
      <Box display="flex" flexDirection="column" gap="12">
        {processAnswer.userAnswer ? (
          <Box bgcolor="bg.light.primary" radius="m" px="12" py="8">
            <TruncatedText
              text={processAnswer.userAnswer || ''}
              rows={4}
              buttonVariant="tertiary"
            />
          </Box>
        ) : (
          <Box radius="m" bgcolor="bg.light.primary" px="12" py="8">
            <Typography variant="body3" color="text.light.tertirary">
              Без ответа
            </Typography>
          </Box>
        )}

        {canDownloadReport && (
          <Callout bordered variant="paper">
            <Typography variant="body3">
              Скачайте отчет для просмотра ответов всех участников
            </Typography>
          </Callout>
        )}
      </Box>
    );
  }
};
